module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "profile",
    attrs: {
      "fluid": ""
    }
  }, [_c('app-snackbar', {
    attrs: {
      "text": _vm.snackBarText,
      "show": _vm.snackbar,
      "color": _vm.snackbarColor,
      "timeOut": _vm.timeOut
    },
    on: {
      "update:show": function($event) {
        _vm.snackbar = $event
      }
    }
  }), _vm._v(" "), _c('coming-soon-modal', {
    attrs: {
      "dialog": _vm.dialog
    },
    on: {
      "update:dialog": function($event) {
        _vm.dialog = $event
      }
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "flex",
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('div', [_c('v-text-field', {
    staticClass: "font input-text",
    attrs: {
      "readonly": !_vm.isNameEditable,
      "prepend-inner-icon": "face",
      "append-icon": _vm.iconEditName,
      "name": "name",
      "id": "name",
      "rules": _vm.$ponceConfig.nameRules,
      "type": "name",
      "color": "0099E1"
    },
    on: {
      "click:append": _vm.editName
    },
    model: {
      value: (_vm.User.name),
      callback: function($$v) {
        _vm.$set(_vm.User, "name", $$v)
      },
      expression: "User.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "font input-text",
    attrs: {
      "readonly": !_vm.isPhoneEditable,
      "prepend-inner-icon": "phone",
      "append-icon": _vm.iconEditPhone,
      "name": "phone",
      "id": "phone",
      "rules": _vm.$ponceConfig.phoneRules,
      "type": "text",
      "color": "0099E1"
    },
    on: {
      "click:append": _vm.editPhone
    },
    model: {
      value: (_vm.User.phone),
      callback: function($$v) {
        _vm.$set(_vm.User, "phone", $$v)
      },
      expression: "User.phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "font input-text",
    attrs: {
      "readonly": !_vm.isMailEditable,
      "prepend-inner-icon": "email",
      "append-icon": _vm.iconEditMail,
      "name": "mail",
      "id": "mail",
      "rules": _vm.$ponceConfig.emailRules,
      "type": "mail",
      "color": "0099E1"
    },
    on: {
      "click:append": _vm.editMail
    },
    model: {
      value: (_vm.User.email),
      callback: function($$v) {
        _vm.$set(_vm.User, "email", $$v)
      },
      expression: "User.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "change-password-div"
  }, [_c('v-icon', {
    staticClass: "inline"
  }, [_vm._v("lock")]), _c('p', {
    staticClass: "font inline change-password-text"
  }, [_vm._v("Cambiar contraseña")]), _c('v-icon', {
    staticClass: "inline to-right",
    on: {
      "click": _vm.editPassword
    }
  }, [_vm._v("email")])], 1), _vm._v(" "), _c('v-select', {
    attrs: {
      "prepend-icon": "person",
      "item-text": "label",
      "item-value": "id",
      "items": _vm.allRoles
    },
    on: {
      "change": _vm.editRole
    },
    model: {
      value: (_vm.User.Role.id),
      callback: function($$v) {
        _vm.$set(_vm.User.Role, "id", $$v)
      },
      expression: "User.Role.id"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03c436fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Profile.vue
// module id = 755
// module chunks = 5